import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { objectWithoutProperties, extendClass } from '../../../utils/utils'
import useTheme from "hooks/useTheme";

var propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    fixed: PropTypes.bool,
    tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};

var defaultProps = {
    tag: 'header',
    fixed: false
};


const AppHeader = (props) => {
    const themeInformation = useTheme();

    useEffect(() => {
        isFixed(props.fixed);
    });


    function isFixed(fixed) {
        if (fixed) {
            document.body.classList.add('header-fixed');
        }
    }


    var _props = props,
        className = _props.className,
        children = _props.children,
        Tag = _props.tag,
        attributes = objectWithoutProperties(_props, ['className', 'children', 'tag']);

    delete attributes.fixed;

    var classes = classNames(className, 'app-header', 'navbar', `app-theme-${themeInformation.theme} `);

    return React.createElement(
        Tag,
        extendClass({ className: classes }, attributes),
        children
    )
}

AppHeader.propTypes = propTypes;
AppHeader.defaultProps = defaultProps;

export default AppHeader;